import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        user:{
            loggedIn: false,
            //email: null,
            username: null
        }
    },
    getters:{
        getUser(state){
            return state.user
        }
    },
    mutations:{
        setUserM(state,  uvalue){
            state.user.loggedIn = true;
            //state.user.email = evalue;
            state.user.username = uvalue;
        },
        logoutM(state){
            state.user.loggedIn = false;
            state.user.email = null;
            state.user.username = null;
        }
    },
    actions:{
        setUser: (context, uvalue) =>{
            context.commit('setUserM', uvalue)
        },
        logOut: context =>{
            context.commit('logoutM')
        }
    }
})